import styled from 'styled-components';
import { SpotTagStyleProps } from './spotTag.types';
import { StyledButton } from '../Button/button.style';
import Link from '../Link/link';
import COLORS from '../../style/universal.color';

const { linkBlue, mlbWhite, mlbGrey2, mlbGrey7 } = COLORS;

export const SpotTagContainer = styled.div`
  display: flex;
  align-items: center;

  ${StyledButton} {
    margin-left: 0.5rem;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const SpotLink = styled(Link)``;

export const SpotTagCopy = styled.div<SpotTagStyleProps>`
  ${({ isMultiline, isSpotTile }) => {
    if (isSpotTile) {
      return 'padding-top: 8px;';
    } else if (isMultiline) {
      return 'padding-left: 10px;';
    } else {
      return 'padding-left: 0.5rem;';
    }
  }};
`;

export const SpotWrapper = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

export const TagName = styled.div<SpotTagStyleProps>`
  font-size: ${({ fontsizeOverride }) => fontsizeOverride || 16}px;
  font-weight: bold;
  color: ${({ dark }) => (dark ? mlbWhite : mlbGrey7)};
  padding-bottom: ${({ isSpotTile }) => (isSpotTile ? 0.5 : 1)}px;
  padding-top: ${({ isSpotTile }) => (isSpotTile ? 0.5 : 1)}px;
  white-space: nowrap;
`;

export const SuperTagName = styled(TagName)`
  font-size: 17px;
  font-weight: normal;
`;

export const SpotTile = styled.button<SpotTagStyleProps>`
  background: none;
  border-radius: 8px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  width: 114px;
  height: 110px;

  ${({ active, activeBorderColor }) => {
    if (active) {
      return `border: 3px solid ${activeBorderColor || linkBlue};`;
    } else {
      return `border: 1px solid ${mlbGrey2};`;
    }
  }};

  ${SuperTagName}, ${TagName} {
    font-size: 13px;
  }
`;
